// client/src/api/factureVenteApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Créer une nouvelle facture de vente
export const createFactureVente = async (factureData) => {
  const response = await axios.post(`${API_URL}/factures-vente`, factureData);
  return response.data;
};

// Lister toutes les factures de vente
export const fetchFacturesVente = async () => {
  const response = await axios.get(`${API_URL}/factures-vente`);
  return response.data;
};

// Récupérer une facture de vente par ID
export const fetchFactureVenteById = async (id) => {
  const response = await axios.get(`${API_URL}/factures-vente/${id}`);
  return response.data;
};

// Mettre à jour une facture de vente
export const updateFactureVente = async (id, factureData) => {
  const response = await axios.put(`${API_URL}/factures-vente/${id}`, factureData);
  return response.data;
};

// Supprimer une facture de vente
export const deleteFactureVente = async (id) => {
  await axios.delete(`${API_URL}/factures-vente/${id}`);
};
